import React from "react";
import { Pill } from "./KgInspectorInstancePill.styles";
import type { KgInspectorInstancePillProps } from "./KgInspectorInstancePill.types";

export const KgInspectorInstancePill: React.FC<KgInspectorInstancePillProps> = ({
  label,
}) => <Pill>{label}</Pill>;

export default KgInspectorInstancePill;
